import React from "react";
import { Alert, AlertDescription, AlertTitle } from "@/components/ui/alert";
import { AlertTriangle } from "lucide-react";
import { Button } from "@/components/ui/button";

const ErrorState = ({ title = "Something went wrong", description, onRetry }) => (
  <Alert variant="destructive" data-testid="error-state">
    <AlertTriangle className="h-4 w-4" />
    <AlertTitle>{title}</AlertTitle>
    {description && <AlertDescription className="mt-1">{description}</AlertDescription>}
    {onRetry && (
      <div className="mt-3">
        <Button size="sm" variant="outline" onClick={onRetry}>
          Retry
        </Button>
      </div>
    )}
  </Alert>
);

export default ErrorState;
